var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcHalfStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "16px",
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rate-Copy",
    transform: "translate(-1074.000000, -409.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1009.545455, 405.727273)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(64.453935, 3.272527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.18231089,0.0004 L8.18231089,12.5204 L3.56231089,15.3594 C3.46131089,15.4204 3.33131089,15.4394 3.21131089,15.4104 C2.98231089,15.3504 2.84231089,15.1004 2.90231089,14.8704 L4.24231089,9.7294 L0.161310887,6.3504 C0.0623108872,6.2704 0.00131088723,6.1604 0.00131088723,6.0404 C-0.0176891128,5.7904 0.172310887,5.5804 0.411310887,5.5704 L5.74231089,5.2204 L7.77231089,0.2804 C7.81231089,0.1704 7.90231089,0.0804 8.01231089,0.0404 C8.07231089,0.0104 8.12131089,0.0004 8.18231089,0.0004",
    id: "Fill-1",
    fill: "#FF7800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2018109,6.35 L12.1118109,9.73 L13.4618109,14.871 C13.4918109,14.98 13.4728109,15.11 13.4118109,15.21 C13.2818109,15.42 13.0018109,15.491 12.7918109,15.36 L8.18181089,12.52 L8.18181089,4.20108393e-13 C8.35181089,4.20108393e-13 8.52181089,0.1 8.59281089,0.28 L10.6118109,5.22 L15.9518109,5.57 C16.0718109,5.57 16.1918109,5.63 16.2628109,5.73 C16.4228109,5.92 16.3918109,6.2 16.2018109,6.35",
    id: "Fill-4",
    fill: "#EEEEEE"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHalfStar);
export default __webpack_public_path__ + "static/media/ic_half_star.51995e2e.svg";
export { ForwardRef as ReactComponent };